module.exports = __webpack_public_path__ + "img/5faa680875a5df5e8f666e44.8f441259.png";